import React from 'react';
import Reference from './ReferenceFormGroup';
import Unifier from './UnifierFormGroup';

const Factoring = ({
  reference,
  unifier,
  index,
  onReference,
  onUnifier,
  onFocus,
  onBlur
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(Reference, {
    reference: reference,
    index: index,
    number: 1,
    onReference: onReference,
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/React.createElement(Unifier, {
    unifier: unifier,
    index: index,
    onUnifier: onUnifier,
    onFocus: onFocus,
    onBlur: onBlur
  }));
};

export default Factoring;